// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1SkippedResourceSchema = z.object({
  id: z.number().int().describe("Resource ID"),
  error: z.coerce.string().min(1).describe("Reason the resource was skipped"),
});
